import React from 'react';
import { seasonOptions } from '../data/vehicleData.js';
import SafeIcon from '../common/SafeIcon.jsx';
import * as FiIcons from 'react-icons/fi';

const { FiSun, FiCloud, FiSnowflake, FiLeaf } = FiIcons;

const seasonIcons = {
  spring: FiLeaf,
  summer: FiSun,
  autumn: FiLeaf,
  winter: FiSnowflake
};

const SeasonSelector = ({ selectedSeason, onSeasonChange }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800">Season</h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {seasonOptions.map((season) => (
          <div
            key={season.id}
            onClick={() => onSeasonChange(season.id)}
            className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 text-center ${
              selectedSeason === season.id
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <SafeIcon 
              icon={seasonIcons[season.id]} 
              className="mx-auto mb-2 text-2xl text-gray-600"
            />
            <h4 className="font-medium text-gray-800 text-sm">{season.name}</h4>
            <p className="text-xs text-gray-600 mt-1">{season.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SeasonSelector;